import {
  SET_FILTER_FORM_CONFIG,
  SET_DOCUMENT_CATEGORIES_DATA,
  SET_DOCUMENT_FORM_DATA,
  SET_DOCUMENT_DETAIL_DATA,
  SET_DOCUMENT_NOTIFY_DATA,
  SET_DOCUMENT_GUIDELINE_DATA,
  SET_FILTER_NOTIFY_CONFIG,
  SET_FILTER_GUIDELINE_CONFIG,
} from './constants';

export const initialState = {
  documentData: [],
  documentNotifyData: [],
  documentGuidelineData: [],
  filterFormConfig: {
    name: '',
    pageNumber: 0,
    limit: 50,
    sort: '',
    exclusiveStartKey: '',
    category: '',
    type: 'FORM',
  },
  filterNotifyConfig: {
    name: '',
    pageNumber: 0,
    limit: 50,
    sort: '',
    exclusiveStartKey: '',
    category: '',
    type: 'Memo',
  },
  filterGuidelineConfig: {
    name: '',
    pageNumber: 0,
    limit: 50,
    sort: '',
    exclusiveStartKey: '',
    category: '',
    type: 'GUIDE_LINE',
  },
  docDetailData: null,
  documentCategoriesData: [],
};

const documentReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_DOCUMENT_FORM_DATA:
      state = {
        ...state,
        documentData: payload,
      };
      break;
    case SET_DOCUMENT_NOTIFY_DATA:
      state = {
        ...state,
        documentNotifyData: payload,
      };
      break;
    case SET_DOCUMENT_GUIDELINE_DATA:
      state = {
        ...state,
        documentGuidelineData: payload,
      };
      break;
    case SET_DOCUMENT_CATEGORIES_DATA:
      state = {
        ...state,
        documentCategoriesData: payload,
      };
      break;
    case SET_FILTER_FORM_CONFIG:
      state = {
        ...state,
        filterFormConfig: payload,
      };
      break;
    case SET_FILTER_NOTIFY_CONFIG:
      state = {
        ...state,
        filterNotifyConfig: payload,
      };
      break;
    case SET_FILTER_GUIDELINE_CONFIG:
      state = {
        ...state,
        filterGuidelineConfig: payload,
      };
      break;
    case SET_DOCUMENT_DETAIL_DATA:
      state = {
        ...state,
        docDetailData: payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default documentReducers;
